import { render, staticRenderFns } from "./LivroDiario.vue?vue&type=template&id=cae814e0&"
import script from "./LivroDiario.vue?vue&type=script&lang=js&"
export * from "./LivroDiario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports